import { Skeleton } from 'antd';

export function PageSkeleton() {
  return (
    <div className='w-full h-full p-6 space-y-6 bg-wl-background rounded-xl'>
      {/* Page title */}
      <Skeleton.Input
        active
        size='large'
        className='w-1/3 rounded-lg dark:bg-gray-200'
      />

      {/* Repeating content blocks (e.g., cards or list items) */}
      {[...Array(2)].map((_, i) => (
        <div
          key={i}
          className='w-full p-4 border border-wl-on-background opacity-20 rounded-lg space-y-4'
        >
          <Skeleton.Input
            active
            size='default'
            className='w-1/2 h-6 rounded dark:bg-gray-200'
          />
          <Skeleton
            paragraph={{ rows: 2, width: ['80%', '100%'] }}
            active
            className='rounded dark:bg-gray-200'
          />
        </div>
      ))}
    </div>
  );
}
